/**
 * O app abre o link de vídeo numa WebView, então o cadastro aceita tanto
 * arquivos (mp4 do Storage, mp4 resolvido pela API do Vimeo) quanto páginas
 * (vimeo.com/123, YouTube, Google Drive...). No navegador, `<video>` só toca
 * arquivos: páginas precisam virar o player embutido do provedor.
 *
 * Retorna { kind: 'file' | 'embed', url }.
 */

const VIDEO_FILE_PATTERN = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?|#|$)/i;

const EMBED_RESOLVERS = [
    // vimeo.com/123, vimeo.com/123/hash (não listado), player.vimeo.com/video/123
    link => {
        // Já é o player embutido (pode carregar ?h= de vídeo não listado): usa como está.
        if (/player\.vimeo\.com\/video\/\d+/i.test(link)) return link;

        const match = link.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-z0-9]+))?/i);
        if (!match) return null;

        const hashParam = match[2] ? `?h=${match[2]}` : '';
        return `https://player.vimeo.com/video/${match[1]}${hashParam}`;
    },
    // youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID, youtube.com/shorts/ID
    link => {
        const match = link.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/i);
        return match ? `https://www.youtube.com/embed/${match[1]}` : null;
    },
    // drive.google.com/file/d/ID/view
    link => {
        const match = link.match(/drive\.google\.com\/file\/d\/([\w-]+)/i);
        return match ? `https://drive.google.com/file/d/${match[1]}/preview` : null;
    }
];

export const resolveVideoSource = link => {
    if (VIDEO_FILE_PATTERN.test(link)) return { kind: 'file', url: link };

    for (const resolveEmbed of EMBED_RESOLVERS) {
        const embedUrl = resolveEmbed(link);
        if (embedUrl) return { kind: 'embed', url: embedUrl };
    }

    // Link desconhecido: mesmo comportamento do app (carrega a página).
    return { kind: 'embed', url: link };
};
